const GAME_REFERRER_CODE_KEY = "game_referrer_code"

export function getStoredGameReferrerCode(): string | null {
  try {
    const raw = localStorage.getItem(GAME_REFERRER_CODE_KEY)
    const trimmed = String(raw ?? "").trim()
    return trimmed || null
  } catch {
    return null
  }
}

export function setStoredGameReferrerCode(code: string): void {
  const trimmed = String(code ?? "").trim()
  if (!trimmed) return
  try {
    localStorage.setItem(GAME_REFERRER_CODE_KEY, trimmed)
  } catch {
    /* ignore */
  }
}

export function clearStoredGameReferrerCode(): void {
  try {
    localStorage.removeItem(GAME_REFERRER_CODE_KEY)
  } catch {
    /* ignore */
  }
}
